import React from 'react';
import { getTranslationKey } from '../../modules/utils/helpers';

interface PricingSwitchProps {
  intervall: string;
  onClick: (event: React.MouseEvent<HTMLElement>) => void;
}

const PricingSwitch: React.FC<PricingSwitchProps> = ({ intervall, onClick }) => (
  <ul className="select-price text-center" onClick={onClick}>
    <li className={intervall === 'monthly' ? 'active' : ''}>
      {getTranslationKey('pricingTables.monthlyPlan')}
    </li>
    <li className={intervall === 'yearly' ? 'active' : ''}>
      {getTranslationKey('pricingTables.yearlyPlan')}
    </li>
  </ul>
);

export default PricingSwitch;
